export default __webpack_public_path__ + "static/media/faq-banner-thumb.820f8aee.png";